/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Copy_CommandInputs */

const en_directory_home_hero_copy_command = /** @type {(inputs: Directory_Home_Hero_Copy_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy command`)
};

const zh_directory_home_hero_copy_command = /** @type {(inputs: Directory_Home_Hero_Copy_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制命令`)
};

/**
* | output |
* | --- |
* | "Copy command" |
*
* @param {Directory_Home_Hero_Copy_CommandInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_copy_command = /** @type {((inputs?: Directory_Home_Hero_Copy_CommandInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Copy_CommandInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_copy_command(inputs)
	return zh_directory_home_hero_copy_command(inputs)
});
export { directory_home_hero_copy_command as "directory.home.hero.copy_command" }